<div class="budget-content">
  <!-- Contenedor interno para el resto del contenido -->
  <div class="main-content-inner">
    <!-- Datos editables inline -->
    <div class="details-data-section" [ngStyle]="{
           'grid-template-columns': 'repeat(' + ((screenService.isMobile$ | async) ? 1 : 2) + ', 1fr)',
           'gap': ((screenService.isMobile$ | async) ? '0px' : '54px')
         }">
      <!-- Primera columna -->
      <div class="details-column">
        <!-- Nombre -->
        <div class="detail-row">
          <span class="detail-label">Nombre:</span>
          <span *ngIf="!isFieldEditing('name')" class="detail-value" (click)="onFieldClick('name', $event)"
            [style.cursor]="canEditField('name') ? 'pointer' : 'default'">
            {{ saleOrderName }}
          </span>
          <input *ngIf="isFieldEditing('name')" type="text" nzSize="large" nz-input [ngModel]="budget?.name || ''"
            (blur)="onFieldBlur('name', $event)" [attr.data-field]="'name'" placeholder="Introduce nombre..."
            (keydown.enter)="confirmTextFieldEdit('name', $event)"
            style="width: 200px;">
        </div>

        <!-- Activo -->
        <div class="detail-row">
          <span class="detail-label">Activa:</span>
          <label nz-checkbox [ngModel]="budget?.isActive" (ngModelChange)="onCheckboxChange('isActive', $event)"
            [nzDisabled]="!canEditField('isActive')">
          </label>
        </div>

        <!-- Empresa cliente -->
        <div *ngIf="customerCompanyName !== '-'" class="detail-row">
          <span class="detail-label">Empresa cliente:</span>
          <div class="detail-tag">
            <nz-avatar *ngIf="budget?.customerCompany || budget?.lead?.customerCompany || budget?.partner?.parent || budget?.lead?.partner?.parent"
              [nzSize]="20"
              [nzSrc]="(budget?.customerCompany?.avatar || budget?.lead?.customerCompany?.avatar || budget?.partner?.parent?.avatar || budget?.lead?.partner?.parent?.avatar) ? getSafeImageUrl(budget?.customerCompany?.avatar || budget?.lead?.customerCompany?.avatar || budget?.partner?.parent?.avatar || budget?.lead?.partner?.parent?.avatar) : undefined"
              [nzText]="!(budget?.customerCompany?.avatar || budget?.lead?.customerCompany?.avatar || budget?.partner?.parent?.avatar || budget?.lead?.partner?.parent?.avatar) ? getPartnerInitials(budget?.customerCompany || budget?.lead?.customerCompany || budget?.partner?.parent || budget?.lead?.partner?.parent) : undefined"
              [style.backgroundColor]="!(budget?.customerCompany?.avatar || budget?.lead?.customerCompany?.avatar || budget?.partner?.parent?.avatar || budget?.lead?.partner?.parent?.avatar) ? '#ffffff' : undefined"
              [style.color]="!(budget?.customerCompany?.avatar || budget?.lead?.customerCompany?.avatar || budget?.partner?.parent?.avatar || budget?.lead?.partner?.parent?.avatar) ? '#000000' : undefined"
              [style.border]="!(budget?.customerCompany?.avatar || budget?.lead?.customerCompany?.avatar || budget?.partner?.parent?.avatar || budget?.lead?.partner?.parent?.avatar) ? '1px solid #d9d9d9' : undefined"
              [style.fontWeight]="!(budget?.customerCompany?.avatar || budget?.lead?.customerCompany?.avatar || budget?.partner?.parent?.avatar || budget?.lead?.partner?.parent?.avatar) ? '600' : undefined" style="margin-right: 8px;">
            </nz-avatar>
            <span>{{ customerCompanyName }}</span>
          </div>
        </div>

        <!-- Contacto -->
        <div class="detail-row">
          <span class="detail-label">Contacto:</span>
          <div *ngIf="!isFieldEditing('partnerId')" class="detail-tag" (click)="onFieldClick('partnerId', $event)"
            [style.cursor]="canEditField('partnerId') ? 'pointer' : 'default'">
            <nz-avatar *ngIf="budget?.contact || budget?.partner" [nzSize]="20"
              [nzSrc]="(budget?.contact?.avatar || budget?.partner?.avatar) ? getSafeImageUrl(budget?.contact?.avatar || budget?.partner?.avatar) : undefined"
              [nzText]="!(budget?.contact?.avatar || budget?.partner?.avatar) ? getPartnerInitials(budget?.contact || budget?.partner) : undefined"
              [style.backgroundColor]="!(budget?.contact?.avatar || budget?.partner?.avatar) ? '#ffffff' : undefined"
              [style.color]="!(budget?.contact?.avatar || budget?.partner?.avatar) ? '#000000' : undefined"
              [style.border]="!(budget?.contact?.avatar || budget?.partner?.avatar) ? '1px solid #d9d9d9' : undefined"
              [style.fontWeight]="!(budget?.contact?.avatar || budget?.partner?.avatar) ? '600' : undefined" style="margin-right: 8px;">
            </nz-avatar>
            <span>{{ contactName }}</span>
          </div>
          <app-avatar-select *ngIf="isFieldEditing('partnerId')" [ngModel]="budget?.partnerId"
            (ngModelChange)="onSelectChange('partnerId', $event)" [options]="partnerList"
            placeholder="Selecciona el Contacto..." style="width: 200px;" [attr.data-field]="'partnerId'">
          </app-avatar-select>
        </div>

        <!-- Drive URL -->
        <!-- <div class="detail-row">
          <span class="detail-label">Drive URL:</span>
          <span *ngIf="!isFieldEditing('driveUrl')"
                class="detail-value"
                (click)="onFieldClick('driveUrl', $event)"
                [style.cursor]="(isEditModeEnabled && editPermissions) ? 'pointer' : 'default'">
            {{ budget?.driveUrl || '-' }}
          </span>
          <input
            *ngIf="isFieldEditing('driveUrl')"
            type="text"
            nzSize="large"
            nz-input
            [ngModel]="budget?.driveUrl || ''"
            (blur)="onFieldBlur('driveUrl', $event)"
            [attr.data-field]="'driveUrl'"
            placeholder="Introduce URL..."
            style="width: 200px;">
        </div> -->

        <!-- Plantilla de presupuesto -->
        <!-- <div class="detail-row">
          <span class="detail-label">Plantilla de presupuesto:</span>
          <span *ngIf="!isFieldEditing('budgetTemplate')"
                class="detail-value"
                (click)="onFieldClick('budgetTemplate', $event)"
                [style.cursor]="(isEditModeEnabled && editPermissions) ? 'pointer' : 'default'">
            {{ getBudgetTemplateName(budget?.budgetTemplate) }}
          </span>
          <nz-select
            *ngIf="isFieldEditing('budgetTemplate')"
            nzSize="large"
            [ngModel]="budget?.budgetTemplate"
            (ngModelChange)="onSelectChange('budgetTemplate', $event)"
            (nzOpenChange)="!$event && stopEditingField('budgetTemplate')"
            nzPlaceHolder="Seleccione plantilla"
            [nzAllowClear]="false"
            nzShowSearch
            style="width: 200px;">
            <nz-option
              *ngFor="let template of budgetTemplates"
              [nzValue]="template.id"
              [nzLabel]="template.name">
            </nz-option>
          </nz-select>
        </div> -->
      </div>

      <!-- Segunda columna -->
      <div class="details-column">
        <!-- Vencimiento -->
        <div class="detail-row">
          <span class="detail-label">Vencimiento:</span>
          <span *ngIf="!isFieldEditing('expirationDate')" class="detail-value"
            (click)="onFieldClick('expirationDate', $event)"
            [style.cursor]="canEditField('expirationDate') ? 'pointer' : 'default'">
            {{ getFormattedDate(budget?.expirationDate) }}
          </span>
          <nz-date-picker *ngIf="isFieldEditing('expirationDate')" class="budget-header-date-picker" data-field="expirationDate"
            [nzClassName]="'budget-header-date-picker'" nzSize="large" [ngModel]="cachedDatePickerValue"
            (ngModelChange)="onSimpleDateChange('expirationDate', $event)" nzPlaceHolder="Seleccione fecha"
            (nzOpenChange)="onEditOverlayOpenChange('expirationDate', $event)"
            [nzFormat]="'dd/MM/yyyy'" [nzShowToday]="true" [nzAllowClear]="false" style="width: 200px;">
          </nz-date-picker>
        </div>

        <!-- Fecha de creación -->
        <div class="detail-row">
          <span class="detail-label">Fecha de creación:</span>
          <span class="detail-value">
            {{ getFormattedDate(budget?.createdOn || todayISOString) }}
          </span>
        </div>

        <!-- Lista de precios -->
        <div class="detail-row">
          <span class="detail-label">Divisa:</span>
          <span *ngIf="!isFieldEditing('currencyId')" class="detail-value" (click)="onFieldClick('currencyId', $event)"
            [style.cursor]="canEditField('currencyId') ? 'pointer' : 'default'">
            {{ getCurrencyName(budget?.currencyId) }}
          </span>
          <nz-select *ngIf="isFieldEditing('currencyId')" nzSize="large" [ngModel]="budget?.currencyId"
            (ngModelChange)="onSelectChange('currencyId', $event)"
            (nzOpenChange)="onEditOverlayOpenChange('currencyId', $event)" nzPlaceHolder="Seleccione moneda"
            [nzAllowClear]="false" nzShowSearch style="width: 200px;" [attr.data-field]="'currencyId'">
            <nz-option *ngFor="let currency of priceLists" [nzValue]="currency.id" [nzLabel]="currency.name">
            </nz-option>
          </nz-select>
        </div>

        <!-- Condiciones de pago -->
        <!-- <div class="detail-row">
          <span class="detail-label">Condiciones de pago:</span>
          <span *ngIf="!isFieldEditing('paymentConditions')"
                class="detail-value"
                (click)="onFieldClick('paymentConditions', $event)"
                [style.cursor]="(isEditModeEnabled && editPermissions) ? 'pointer' : 'default'">
            {{ getPaymentConditionName(budget?.paymentConditions) }}
          </span>
          <nz-select
            *ngIf="isFieldEditing('paymentConditions')"
            nzSize="large"
            [ngModel]="budget?.paymentConditions"
            (ngModelChange)="onSelectChange('paymentConditions', $event)"
            (nzOpenChange)="!$event && stopEditingField('paymentConditions')"
            nzPlaceHolder="Seleccione condiciones"
            [nzAllowClear]="false"
            nzShowSearch
            style="width: 200px;">
            <nz-option
              *ngFor="let condition of paymentConditions"
              [nzValue]="condition.id"
              [nzLabel]="condition.name">
            </nz-option>
          </nz-select>
        </div> -->
      </div>
    </div>

    <!-- Notificación de cambio de moneda (visible en todos los tabs) -->
    @if (showCurrencyChangeNotification) {
    <nz-alert nzType="info" nzMessage="Los totales han sido recalculados según la nueva moneda del presupuesto. Los cambios se guardarán al presionar 'Guardar'."
      [nzShowIcon]="true" [nzCloseable]="true" (nzOnClose)="showCurrencyChangeNotification = false"
      style="margin-top: 32px; margin-bottom: 16px;"></nz-alert>
    }

    <!-- Tabs: Líneas del pedido y Presupuesto -->
    <nz-tabset *ngIf="afterViewInit" [(nzSelectedIndex)]="activeTabIndex" style="margin-top: 32px;">
      <nz-tab [nzTitle]="lineasPedidoTemplate">
        <ng-template #lineasPedidoTemplate>
          <app-st-icon style="margin-right: 5px" [name]="'list'"></app-st-icon>
          Presupuesto a cliente
        </ng-template>
        <div class="tab-content">
          <!-- Tabla de líneas del pedido -->
          <nz-table [nzData]="quotationLines" [nzShowPagination]="false" [nzFrontPagination]="false"
            [nzScroll]="{ x: 'auto'}" class="st-bordered budget-table-header" [nzNoResult]="emptyTemplate"
            style="margin-top: 25px">
            <thead>
              <tr>
                @for (column of tableColumns; track column.key) {
                <th [nzRight]="column.fixed ? '0px' : false" [class.shadowed-before]="column.fixed">{{ column.label }}
                </th>
                }
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let line of quotationLines; let i = index">
                @for (column of tableColumns; track column.key) {
                <td (click)="column.key !== 'amount' && !(column.key === 'unit' && line.product && line.product !== 0) ? startEditingCell(column.key, i) : null"
                  [class.cursor-pointer]="isEditModeEnabled && editPermissions && column.key !== 'amount' && !(column.key === 'unit' && line.product && line.product !== 0)"
                  [class.editable-cell]="isEditModeEnabled && editPermissions && column.key !== 'amount' && !(column.key === 'unit' && line.product && line.product !== 0)"
                  [class.editing]="isEditingCell(column.key, i)" [class.color-grey-9]="isEmptyValue(line, column)"
                  [class.line-name-cell]="column.key === 'name'"
                  [class.shadowed-before]="column.fixed" [nzRight]="column.fixed ? '0px' : false">
                  <div [hidden]="isEditingCell(column.key, i)"
                    style="display: flex; align-items: center; justify-content: space-between;">
                    <div class="budget-cell-value">
                      @if (column.key === 'supplier') {
                      {{ getSupplierName(line[column.key]) }}
                      } @else if (column.key === 'product') {
                      <div class="line-product-cell">
                        <div class="line-product-header">
                          <span class="line-product-name">{{ getProductName(line[column.key], line.productName) }}</span>
                          @if (editPermissions) {
                          <button nz-button nzType="text" nzSize="small" nzShape="circle" class="line-note-action"
                            nz-tooltip nzTooltipTitle="Agregar nota" nzTooltipPlacement="top"
                            (click)="startEditingLineNote(line, i, $event)">
                            <app-st-icon [name]="getLineNote(line) ? 'edit_note' : 'note_add'" [bold]="true"></app-st-icon>
                          </button>
                          }
                        </div>
                        @if (isEditingLineNote(i)) {
                        <div class="line-note-editor" (click)="$event.stopPropagation()">
                          <textarea #lineNoteInput nz-input rows="2" [(ngModel)]="lineNoteDraft"
                            [ngModelOptions]="{standalone: true}" placeholder="Escribe una nota..."
                            (blur)="saveLineNote(line, i, $event)"
                            (keydown)="onLineNoteKeydown($event, line, i)"></textarea>
                          <button nz-button nzType="text" nzShape="circle" nzSize="small" class="line-note-save"
                            (mousedown)="$event.preventDefault()" (click)="saveLineNote(line, i, $event)">
                            <app-st-icon name="check" [bold]="true"></app-st-icon>
                          </button>
                          <button nz-button nzType="text" nzShape="circle" nzSize="small" class="line-note-cancel"
                            (mousedown)="$event.preventDefault()" (click)="cancelLineNoteEditing($event)">
                            <app-st-icon name="close" [bold]="true"></app-st-icon>
                          </button>
                        </div>
                        } @else {
                        <div class="line-note-view" [class.has-note]="getLineNote(line)">
                          @if (getLineNote(line)) {
                          <span class="line-note-text">{{ getLineNote(line) }}</span>
                          }
                        </div>
                        }
                      </div>
                      } @else if (column.key === 'unit') {
                      {{ getUnitName(line[column.key]) }}
                      } @else if (column.key === 'taxes') {
                      {{ getLineTaxesLabel(line) }}
                      } @else if (column.key === 'sourceId' || column.key === 'destinationId') {
                      {{ getLocationName(line[column.key]) }}
                      } @else if (column.key === 'amount') {
                      <span class="line-amount-stack">
                        <span>{{ getLineOriginalAmount(line) | currency: getCurrencyCode(line.currency) : 'symbol' : '1.2-2' }}</span>
                        @if (shouldShowLineEquivalent(line)) {
                        <small class="line-amount-equivalent"
                          nz-tooltip
                          [nzTooltipTitle]="getLineEquivalentTooltip(line)"
                          nzTooltipPlacement="top">
                          Equiv. {{ getLineConvertedAmount(line) | currency: budgetCurrencyCode : 'symbol' : '1.2-2' }}
                        </small>
                        }
                        @if (line.wasConverted) {
                          <nz-badge nzStatus="warning"
                                    nz-tooltip
                                    [nzTooltipTitle]="line.conversionTooltip || ''"
                                    nzTooltipPlacement="top">
                          </nz-badge>
                        }
                      </span>
                      } @else if (column.key === 'priceUnit') {
                      {{ line[column.key] | currency: getCurrencyCode(line.currency) : 'symbol' : '1.2-2' }}
                      } @else if (column.format === 'number' && (line[column.key] !== null && line[column.key] !==
                      undefined)) {
                      {{ line[column.key] | number: '1.2-2' }}
                      } @else {
                      {{ line[column.key] || '-' }}
                      }
                    </div>
                    @if (column.key === 'amount') {
                    <a nz-dropdown [nzDropdownMenu]="quotationLineMenu" nzTrigger="click" (click)="$event.stopPropagation()"
                      style="margin-left: 8px; color: #000;">
                      <app-st-icon name="more_vert" [bold]="true"></app-st-icon>
                    </a>
                    <nz-dropdown-menu #quotationLineMenu="nzDropdownMenu">
                      <ul nz-menu>
                        <li nz-menu-item (click)="openEditSaleOrderLineDrawer(line, i)">
                          <button nz-button nzType="text" nzShape="round" nzSize="default" class="flex-center gap-100">
                            <app-st-icon name="edit" [bold]="true"></app-st-icon>
                            <span class="text-label-14 text-dark">Editar</span>
                          </button>
                        </li>
                        <li nz-menu-item (click)="confirmDeleteSaleOrderLine(i)">
                          <button nz-button nzType="text" nzShape="round" nzSize="default" class="flex-center gap-100">
                            <app-st-icon name="delete" [bold]="true"></app-st-icon>
                            <span class="text-label-14 text-dark">Eliminar</span>
                          </button>
                        </li>
                      </ul>
                    </nz-dropdown-menu>
                    }
                  </div>
                  @if (column.type === 'select') {
                  <nz-select [hidden]="!isEditingCell(column.key, i)" nzSize="small"
                    [nzMode]="'default'"
                    [ngModel]="column.key === 'taxes' ? (line[column.key] && line[column.key].length > 0 ? line[column.key][0] : null) : line[column.key]"
                    [ngModelOptions]="{standalone: true}" [nzPlaceHolder]="column.placeholder || ''"
                    (blur)="stopEditingCell(column.key, i)"
                    (nzOpenChange)="column.key === 'taxes' ? ($event ? onTaxSelectOpen(i) : stopEditingCell(column.key, i)) : (!$event && stopEditingCell(column.key, i))"
                    (ngModelChange)="column.key === 'taxes' ? onTaxSelectionChange(i, $event) : onQuotationLineFieldChange(column.key, i, $event)"
                    style="width: 100%;">
                    @if (column.key === 'product') {
                    <nz-option [nzValue]="0" nzLabel="Ninguno"></nz-option>
                    <nz-option *ngFor="let product of productListForSale" [nzValue]="product.id" [nzLabel]="product.name">
                    </nz-option>
                    } @else if (column.key === 'supplier') {
                    <nz-option [nzValue]="0" nzLabel="Ninguno"></nz-option>
                    <nz-option *ngFor="let supplier of supplierList" [nzValue]="supplier.id" [nzLabel]="supplier.name">
                    </nz-option>
                    } @else if (column.key === 'unit') {
                    <nz-option [nzValue]="0" nzLabel="Ninguna"></nz-option>
                    <nz-option *ngFor="let unit of getUnitsForLineProduct(line.product)" [nzValue]="unit.id" [nzLabel]="unit.name">
                    </nz-option>
                    } @else if (column.key === 'taxes') {
                    <nz-option [nzValue]="null" nzLabel="Ninguno"></nz-option>
                    <nz-option *ngFor="let tax of filteredTaxesForQuotationLines[i] || []" [nzValue]="tax.id"
                      [nzLabel]="tax.name + ' (' + (tax.amount?.parsedValue || tax.amount || 0) + '%)'">
                    </nz-option>
                    } @else if (column.key === 'sourceId' || column.key === 'destinationId') {
                    <nz-option [nzValue]="0" nzLabel="Ninguno"></nz-option>
                    <nz-option *ngFor="let location of locationList" [nzValue]="location.id" [nzLabel]="location.name">
                    </nz-option>
                    }
                  </nz-select>
                  } @else {
                  @if (column.key === 'name') {
                  <textarea [hidden]="!isEditingCell(column.key, i)" #tableInput [attr.data-field]="column.key"
                    nzSize="small" nz-input [(ngModel)]="line[column.key]"
                    [ngModelOptions]="{standalone: true}" [placeholder]="column.placeholder || 'Escribe...'"
                    [nzAutosize]="{ minRows: 2, maxRows: 5 }" (blur)="stopEditingCell(column.key, i)"
                    (ngModelChange)="onQuotationLineFieldChange(column.key, i, $event)" style="width: 100%;"></textarea>
                  } @else {
                  <input [hidden]="!isEditingCell(column.key, i)" #tableInput [attr.data-field]="column.key"
                    [type]="column.type" nzSize="small" nz-input [(ngModel)]="line[column.key]"
                    [ngModelOptions]="{standalone: true}" [placeholder]="column.placeholder || 'Escribe...'"
                    (blur)="stopEditingCell(column.key, i)"
                    (ngModelChange)="onQuotationLineFieldChange(column.key, i, $event)" style="width: 100%;" />
                  }
                  }
                </td>
                }
              </tr>
              <!-- Add line row -->
              <tr class="add-line-row">
                <td [attr.colspan]="tableColumns.length - 1" style="padding: 0; width: 0; border: none;">
                  <a (click)="addSaleOrderLine()" class="add-line-link">Añadir un producto</a>
                </td>
                <td [nzRight]="'0px'" class="shadowed-before" style="padding: 0; width: 0; border: none;"></td>
              </tr>
            </tbody>
          </nz-table>

          <!-- Sección de descuento -->
          <aside class="customer-quote-side-panel">
          <div class="discount-section">
            <!--            <div class="discount-title">Descuento</div>-->
            <div style="width: 100%;">
              <nz-divider style="margin: 8px 0;"></nz-divider>
            </div>
            <div class="discount-row">
              <span class="discount-label">Importe base:</span>
              <span class="discount-value">{{ baseAmount | currency: budgetCurrencyCode : 'symbol' : '1.2-2' }}</span>
            </div>
            @for (tax of taxesBreakdown; track tax.taxId) {
            <div class="discount-row">
              <span class="discount-label">{{ tax.taxName }}:</span>
              <span class="discount-value">{{ tax.amount | number : '1.2-2' }}</span>
            </div>
            }
            <div class="discount-row">
              <span class="discount-label">Total:</span>
              <span class="discount-value total-value">{{ total | currency: budgetCurrencyCode : 'symbol' : '1.2-2' }}</span>
            </div>
            <div class="discount-row">
              <span class="discount-label">Margen:</span>
              <span class="discount-value">{{ margin | currency: budgetCurrencyCode : 'symbol' : '1.2-2' }}</span>
            </div>
          </div>

          <div class="customer-terms-section">
            <div class="terms-header">
              <h3 class="section-title">Términos y Condiciones</h3>
              <!-- CEC-692: además del clic sobre el texto, un botón siempre visible para quien no sabe que se puede pinchar. -->
              @if (canStartTermsEdit()) {
              <button nz-button nzType="text" nzShape="circle" class="terms-edit-action"
                nz-tooltip nzTooltipTitle="Editar términos y condiciones" nzTooltipPlacement="top"
                aria-label="Editar términos y condiciones"
                (click)="onFieldClick('terms', $event)">
                <app-st-icon name="edit_note" [bold]="true"></app-st-icon>
              </button>
              }
            </div>
            <div *ngIf="!isFieldEditing('terms')" class="text-label-14 text-dark terms-view"
              [class.terms-edit-mode]="canEditTermsDirectly() || isEditModeEnabled"
              (click)="onFieldClick('terms', $event)">
              <div class="terms-empty-state" *ngIf="!budget?.terms || budget?.terms === '<p><br></p>' || budget?.terms === '<p></p>' || budget?.terms === '<p><br/></p>'">
                <app-st-icon name="edit_note" [bold]="true"></app-st-icon>
                <span>Agregar términos y condiciones</span>
              </div>
              <div class="terms-rich-content rich-text-content" *ngIf="budget?.terms && budget?.terms !== '<p><br></p>' && budget?.terms !== '<p></p>' && budget?.terms !== '<p><br/></p>'" [innerHTML]="sanitizeHtml(budget?.terms)"></div>
            </div>
            <quill-editor #budgetQuillEditor *ngIf="isFieldEditing('terms')"
              [ngModel]="termsEditorContent"
              (ngModelChange)="onQuillContentChanged('terms', $event)"
              (onBlur)="onQuillBlur('terms')"
              [modules]="quillConfig"
              placeholder="Introduce términos y condiciones..."
              [styles]="{height: '300px'}">
            </quill-editor>
          </div>
          </aside>
        </div>
      </nz-tab>

      <nz-tab [nzTitle]="presupuestoTemplate">
        <ng-template #presupuestoTemplate>
          <app-st-icon style="margin-right: 5px" [name]="'paid'"></app-st-icon>
          Presupuesto
        </ng-template>
        <div class="tab-content">
          <!-- Sección de resumen -->
          <div class="summary-section">
            <div nz-row [nzGutter]="32">
              <div nz-col [nzSpan]="12">
                <div class="summary-item">
                  <span class="summary-label">Total Venta:</span>
                  <span class="summary-value">{{ totalSale | currency: budgetCurrencyCode : 'symbol' : '1.2-2' }}</span>
                </div>
                <div class="summary-item">
                  <span class="summary-label">Total Costo:</span>
                  <span class="summary-value">{{ totalCost | currency: budgetCurrencyCode : 'symbol' : '1.2-2' }}</span>
                </div>
              </div>
              <div nz-col [nzSpan]="12">
                <div class="summary-item">
                  <span class="summary-label">Margen Bruto:</span>
                  <span class="summary-value">{{ grossMargin | currency: budgetCurrencyCode : 'symbol' : '1.2-2' }}</span>
                </div>
                <div class="summary-item">
                  <span class="summary-label">Rentabilidad:</span>
                  <span class="summary-value">{{ marginPercent | percent : '1.2-2' }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Tabla de presupuesto -->
          <nz-table [nzData]="displayedBudgetLineRows" [nzShowPagination]="false" [nzFrontPagination]="false"
            [nzScroll]="{ x: 'auto'}" class="st-bordered budget-table-header" [nzNoResult]="emptyTemplate"
            style="margin-top: 25px">
            <thead>
              <tr>
                @for (column of budgetTableColumns; track column.key) {
                <th [nzRight]="column.fixed ? '0px' : false" [class.shadowed-before]="column.fixed">{{ column.label }}
                </th>
                }
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of displayedBudgetLineRows; trackBy: trackBudgetLineRow"
                [class.budget-sale-row]="!row.isAssociatedCost && row.associatedCostCount > 0"
                [class.associated-cost-row]="row.isAssociatedCost">
                @for (column of budgetTableColumns; track column.key) {
                <td [class.color-grey-9]="isEmptyValue(row.line, column)" [class.shadowed-before]="column.fixed"
                  [class.budget-description-cell]="column.key === 'product'"
                  [class.line-name-cell]="column.key === 'name'"
                  [nzRight]="column.fixed ? '0px' : false">
                  <!-- Display value only -->
                  <div class="budget-row-cell">
                    <div class="budget-cell-value">
                      @if (column.key === 'product') {
                      <div class="budget-line-description" [class.associated-cost-description]="row.isAssociatedCost">
                        @if (row.associatedCostCount > 0) {
                        <button nz-button nzType="text" nzSize="small" nzShape="circle" class="budget-expand-button"
                          [attr.aria-expanded]="row.isExpanded"
                          [attr.aria-label]="row.isExpanded ? 'Ocultar costes asociados' : 'Mostrar costes asociados'"
                          nz-tooltip
                          [nzTooltipTitle]="row.isExpanded ? 'Ocultar costes asociados' : 'Mostrar costes asociados'"
                          nzTooltipPlacement="top"
                          (click)="toggleAssociatedCosts(row, $event)">
                          <app-st-icon [name]="row.isExpanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right'" [bold]="true"></app-st-icon>
                        </button>
                        } @else if (row.isAssociatedCost) {
                        <span class="associated-cost-indent" aria-hidden="true"></span>
                        } @else {
                        <span class="budget-expand-spacer" aria-hidden="true"></span>
                        }

                        <div class="line-product-cell">
                          <div class="line-product-header">
                            <span class="line-product-name">{{ getProductName(row.line.product, row.line.productName) }}</span>
                            @if (editPermissions) {
                            <button nz-button nzType="text" nzSize="small" nzShape="circle" class="line-note-action"
                              nz-tooltip nzTooltipTitle="Agregar nota" nzTooltipPlacement="top"
                              (click)="startEditingLineNote(row.line, row.index, $event, 'budget')">
                              <app-st-icon [name]="getLineNote(row.line) ? 'edit_note' : 'note_add'" [bold]="true"></app-st-icon>
                            </button>
                            }
                          </div>
                          @if (isEditingLineNote(row.index, 'budget')) {
                          <div class="line-note-editor" (click)="$event.stopPropagation()">
                            <textarea #lineNoteInput nz-input rows="2" [(ngModel)]="lineNoteDraft"
                              [ngModelOptions]="{standalone: true}" placeholder="Escribe una nota..."
                              (blur)="saveLineNote(row.line, row.index, $event, 'budget')"
                              (keydown)="onLineNoteKeydown($event, row.line, row.index, 'budget')"></textarea>
                            <button nz-button nzType="text" nzShape="circle" nzSize="small" class="line-note-save"
                              (mousedown)="$event.preventDefault()" (click)="saveLineNote(row.line, row.index, $event, 'budget')">
                              <app-st-icon name="check" [bold]="true"></app-st-icon>
                            </button>
                            <button nz-button nzType="text" nzShape="circle" nzSize="small" class="line-note-cancel"
                              (mousedown)="$event.preventDefault()" (click)="cancelLineNoteEditing($event)">
                              <app-st-icon name="close" [bold]="true"></app-st-icon>
                            </button>
                          </div>
                          } @else {
                          <div class="line-note-view" [class.has-note]="getLineNote(row.line)">
                            @if (getLineNote(row.line)) {
                            <span class="line-note-text">{{ getLineNote(row.line) }}</span>
                            }
                          </div>
                          }
                        </div>
                      </div>
                      } @else if (column.key === 'name') {
                      {{ row.line.name || '-' }}
                      } @else if (column.key === 'supplier') {
                      {{ getSupplierName(row.line[column.key]) }}
                      } @else if (column.key === 'taxes') {
                      {{ getLineTaxesLabel(row.line) }}
                      } @else if (column.key === 'associatedSale') {
                      {{ row.line.isCost ? getAssociatedSaleName(row.line[column.key]) : '' }}
                      } @else if (column.key === 'amount') {
                      <span class="line-amount-stack">
                        <span>{{ getLineOriginalAmount(row.line) | currency: getCurrencyCode(row.line.currency) : 'symbol' : '1.2-2' }}</span>
                        @if (shouldShowLineEquivalent(row.line)) {
                        <small class="line-amount-equivalent"
                          nz-tooltip
                          [nzTooltipTitle]="getLineEquivalentTooltip(row.line)"
                          nzTooltipPlacement="top">
                          Equiv. {{ getLineConvertedAmount(row.line) | currency: budgetCurrencyCode : 'symbol' : '1.2-2' }}
                        </small>
                        }
                        @if (row.line.wasConverted) {
                          <nz-badge nzStatus="warning"
                                    nz-tooltip
                                    [nzTooltipTitle]="row.line.conversionTooltip || ''"
                                    nzTooltipPlacement="top">
                          </nz-badge>
                        }
                      </span>
                      } @else if (column.key === 'isCost') {
                      <span class="budget-line-type-label"
                        [class.cost-type]="row.line[column.key]"
                        [class.sale-type]="!row.line[column.key]">
                        {{ row.line[column.key] ? 'Coste' : 'Venta' }}
                      </span>
                      } @else if (column.type === 'boolean') {
                      {{ row.line[column.key] ? 'Sí' : 'No' }}
                      } @else if (column.key === 'price') {
                      {{ row.line[column.key] | currency: getCurrencyCode(row.line.currency) : 'symbol' : '1.2-2' }}
                      } @else if (column.format === 'number' && (row.line[column.key] !== null && row.line[column.key] !==
                      undefined)) {
                      {{ row.line[column.key] | number: '1.2-2' }}
                      } @else {
                      {{ row.line[column.key] || '-' }}
                      }
                    </div>

                    <!-- Actions Menu -->
                    @if (column.key === 'amount') {
                    <a nz-dropdown [nzDropdownMenu]="menu" nzTrigger="click" (click)="$event.stopPropagation()"
                      style="margin-left: 8px; color: #000;">
                      <app-st-icon name="more_vert" [bold]="true"></app-st-icon>
                    </a>
                    <nz-dropdown-menu #menu="nzDropdownMenu">
                      <ul nz-menu>
                        <li nz-menu-item (click)="openBudgetLineSummaryModal(row, $event)">
                          <button nz-button nzType="text" nzShape="round" nzSize="default" class="flex-center gap-100">
                            <app-st-icon name="visibility" [bold]="true"></app-st-icon>
                            <span class="text-label-14 text-dark">Ver detalles</span>
                          </button>
                        </li>
                        @if (editPermissions) {
                        <li nz-menu-item (click)="openEditBudgetLineDrawer(row.line, row.index)">
                          <button nz-button nzType="text" nzShape="round" nzSize="default" class="flex-center gap-100">
                            <app-st-icon name="edit" [bold]="true"></app-st-icon>
                            <span class="text-label-14 text-dark">Editar</span>
                          </button>
                        </li>
                        <li nz-menu-item (click)="confirmDeleteBudgetLine(row.index)">
                          <button nz-button nzType="text" nzShape="round" nzSize="default" class="flex-center gap-100">
                            <app-st-icon name="delete" [bold]="true"></app-st-icon>
                            <span class="text-label-14 text-dark">Eliminar</span>
                          </button>
                        </li>
                        }
                      </ul>
                    </nz-dropdown-menu>
                    }
                  </div>
                </td>
                }
              </tr>
              <!-- Add line row -->
              <tr class="add-line-row">
                <td [attr.colspan]="budgetTableColumns.length - 1" style="padding: 0; width: 0; border: none;">
                  <a (click)="addBudgetLine()" class="add-line-link">Añadir una línea</a>
                </td>
                <td [nzRight]="'0px'" class="shadowed-before" style="padding: 0; width: 0; border: none;"></td>
              </tr>
            </tbody>
          </nz-table>
          <!-- Desglose de impuestos -->
          @if (budgetTaxesBreakdown && budgetTaxesBreakdown.length > 0) {
          <div style="margin-top: 16px; padding-top: 16px; ">
            <div class="summary-item" style="margin-bottom: 8px;">
              <span class="summary-label" style="font-weight: 600;">Impuestos:</span>
            </div>
            @for (tax of budgetTaxesBreakdown; track tax.taxId) {
            <div class="summary-item" style="margin-left: 16px;">
              <span class="summary-label">{{ tax.taxName }}:</span>
              <span class="summary-value">{{ tax.amount | number : '1.2-2' }}</span>
            </div>
            }
          </div>
          }
        </div>
      </nz-tab>

      <nz-tab [nzTitle]="versionesTemplate">
        <ng-template #versionesTemplate>
          <app-st-icon style="margin-right: 5px" [name]="'history'"></app-st-icon>
          Versiones
        </ng-template>
        <app-budget-pdf-versions
          [saleOrderId]="budget?.id ?? null"
          [budgetName]="budget?.name ?? ''"
          [budgetCurrencyCode]="versionsBudgetCurrencyCode"
          [refreshKey]="pdfVersionsRefreshKey"
        ></app-budget-pdf-versions>
      </nz-tab>

    </nz-tabset>
  </div>
</div>
<ng-template #emptyTemplate>
  <!-- Dejar vacío para no mostrar nada -->
</ng-template>
<app-confirmation-modal #deleteLineConfirmationModal
  (confirmed)="onDeleteLineConfirmed($event)"></app-confirmation-modal>

<nz-modal
  [(nzVisible)]="isBudgetLineSummaryModalVisible"
  nzTitle="Detalles de la línea"
  [nzCentered]="true"
  [nzWidth]="560"
  nzClassName="budget-line-summary-modal"
  [nzFooter]="budgetLineSummaryModalFooter"
  (nzOnCancel)="closeBudgetLineSummaryModal()">
  <ng-container *nzModalContent>
    @if (selectedBudgetLineSummary) {
    <div class="line-summary-modal-content">
      <div class="line-summary-header">
        <span class="budget-line-type-label"
          [class.cost-type]="selectedBudgetLineSummary.typeLabel === 'Coste'"
          [class.sale-type]="selectedBudgetLineSummary.typeLabel === 'Venta'">
          {{ selectedBudgetLineSummary.typeLabel }}
        </span>
        <div class="line-summary-description">
          {{ selectedBudgetLineSummary.description }}
        </div>
      </div>

      <div class="line-summary-meta">
        <div class="line-summary-meta-item">
          <span>Producto</span>
          <strong>{{ selectedBudgetLineSummary.productName }}</strong>
        </div>
        @if (selectedBudgetLineSummary.typeLabel === 'Venta') {
        <div class="line-summary-meta-item">
          <span>Costes asociados</span>
          <strong>{{ selectedBudgetLineSummary.associatedCostCount }}</strong>
        </div>
        } @else {
        <div class="line-summary-meta-item">
          <span>Venta asociada</span>
          <strong>{{ selectedBudgetLineSummary.associatedSaleName }}</strong>
        </div>
        }
      </div>

      <div class="line-summary-grid">
        <div class="line-summary-card">
          <span>Total Venta</span>
          <strong>{{ selectedBudgetLineSummary.totalSale | currency: selectedBudgetLineSummary.currencyCode : 'symbol' : '1.2-2' }}</strong>
        </div>
        <div class="line-summary-card">
          <span>Total Costo</span>
          <strong>{{ selectedBudgetLineSummary.totalCost | currency: selectedBudgetLineSummary.currencyCode : 'symbol' : '1.2-2' }}</strong>
        </div>
        <div class="line-summary-card" [class.negative]="selectedBudgetLineSummary.grossMargin < 0">
          <span>Margen Bruto</span>
          <strong>{{ selectedBudgetLineSummary.grossMargin | currency: selectedBudgetLineSummary.currencyCode : 'symbol' : '1.2-2' }}</strong>
        </div>
        <div class="line-summary-card" [class.negative]="selectedBudgetLineSummary.marginPercent < 0">
          <span>Rentabilidad</span>
          <strong>{{ selectedBudgetLineSummary.marginPercent | percent : '1.2-2' }}</strong>
        </div>
      </div>
    </div>
    }
  </ng-container>
</nz-modal>

<ng-template #budgetLineSummaryModalFooter>
  <button nz-button nzType="primary" nzShape="round" nzSize="large" (click)="closeBudgetLineSummaryModal()">
    Cerrar
  </button>
</ng-template>

<!-- Template para el modal de link (contenido + footer en uno para tener contexto del componente) -->
<ng-template #linkModalTemplate let-component="$implicit.component">
  <div class="link-modal-content">
    <label class="link-modal-label">URL del enlace:</label>
    <input
      #linkInput
      type="text"
      [ngModel]="component?.linkModalUrl"
      (ngModelChange)="component && (component.linkModalUrl = $event)"
      placeholder="https://ejemplo.com"
      nz-input
      class="link-modal-input"
      (keydown.enter)="component?.onLinkModalEnter()"
    />
  </div>
  <div class="link-modal-footer">
    <button nz-button nzType="text" nzDanger nzShape="round" nzSize="large" (click)="component?.removeLinkFromSelection()">
      Quitar enlace
    </button>
    <span class="link-modal-footer-spacer"></span>
    <button nz-button nzType="text" nzShape="round" nzSize="large" (click)="component?.closeLinkModal()">Cancelar</button>
    <button nz-button nzType="primary" nzShape="round" nzSize="large" (click)="component?.onLinkModalConfirm()">Aceptar</button>
  </div>
</ng-template>

<!-- CEC-687. Aviso cuando el servidor rechaza guardar una línea: antes solo iba a la consola. -->
<ng-template #notificationTmpl>
  <app-toast
    [notRef]="notRef!"
    [icon]="toastConfig.icon"
    [iconColor]="toastConfig.iconColor"
    [content]="toastConfig.content"
    [msg]="toastConfig.msg"
    [showUndo]="toastConfig.showUndo"
  ></app-toast>
</ng-template>
